import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TextFieldWithButtonAddon',
  props: {
  isSubmitting: {
    type: Boolean,
    required: false,
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
    }),
    required: false,
  },
  error: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  label: {
    type: String,
    required: false,
  },
  buttonLabel: {
    type: String,
    required: false,
  },
  value: {
    type: String,
  },
},
  emits: ["submit", "input"],
  setup(__props) {





return { __sfc: true,Icon }
}

})